<template>
  <div class="pt-24" v-if="isRichContent">
    <RollBlockRich>
      <template v-slot:content>
        <img class="picture" :src="getRichContentImg" />
      </template>
      <template v-slot:text-button> Развернуть </template>
      <template v-slot:text-button-active> Свернуть </template>
    </RollBlockRich>
  </div>
</template>

<script>
import RollBlockRich from "../RollBlock/RollBlockRich.vue";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "RichContentBlock",
  components: {
    RollBlockRich,
  },
  computed: {
    ...mapState(useProductStore, [
      "getSelectedProduct",
      "getRichContentImg",
      "isRichContent",
    ]),
  },
};
</script>
